import * as i0 from '@angular/core';
import { Component, Input, ViewChild, NgModule } from '@angular/core';
import { interval, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { noop } from '@infomaniak/ngx-helpers';

class IkCardSelectableComponent {
    constructor() {
        this.isSelected = false;
        // INFO: force angular to refresh the component for a period of 2000ms
        interval(50)
            .pipe(takeUntil(timer(2000)))
            .subscribe(noop);
    }
    // isElementEmptySoft(
    //   name: keyof this,
    // ): boolean {
    //   return (this[name] !== void 0)
    //     && ((this[name] as any).nativeElement !== void 0)
    //     && ((this[name] as any).nativeElement.innerHTML === '');
    // }
    isElementEmpty(name) {
        return (this[name] === void 0)
            || (this[name].nativeElement === void 0)
            || (this[name].nativeElement.innerHTML === '');
    }
    get hideBadge() {
        return this.isElementEmpty('badge');
    }
    get hideHeader() {
        return this.isElementEmpty('header');
    }
    get hideMain() {
        return this.isElementEmpty('main');
    }
    get hideFooter() {
        return this.isElementEmpty('footer');
    }
}
IkCardSelectableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.15", ngImport: i0, type: IkCardSelectableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IkCardSelectableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.15", type: IkCardSelectableComponent, selector: "ik-card-selectable", inputs: { isSelected: "isSelected" }, viewQueries: [{ propertyName: "badge", first: true, predicate: ["badge"], descendants: true }, { propertyName: "header", first: true, predicate: ["header"], descendants: true }, { propertyName: "main", first: true, predicate: ["main"], descendants: true }, { propertyName: "footer", first: true, predicate: ["footer"], descendants: true }], ngImport: i0, template: "<div class=\"card-selectable\"\n     [class.isSelected]=\"isSelected\">\n  <div\n    #badge\n    [hidden]='hideBadge'\n    class=\"card-selectable-badge\"\n  >\n    <ng-content select=\"[badge]\"></ng-content>\n  </div>\n  <div\n    #header\n    [hidden]='hideHeader'\n    class=\"card-selectable-header\"\n  >\n    <ng-content select=\"[header]\"></ng-content>\n    <div class=\"card-selectable-header__separator\"></div>\n  </div>\n  <div\n    #main\n    [hidden]='hideMain'\n    class=\"card-selectable-main\"\n  >\n    <ng-content select=\"[main]\"></ng-content>\n  </div>\n  <div\n    #footer\n    [hidden]='hideFooter'\n    class=\"card-selectable-footer\"\n  >\n    <ng-content select=\"[footer]\"></ng-content>\n  </div>\n</div>\n", styles: [".fontTinySmall{font-size:12px}.fontTiny{font-size:11px}.fontSmall{font-size:13px}.fontBase{font-size:14px}.fontMediumSmall{font-size:16px}.fontMedium{font-size:18px}.fontMediumLarge{font-size:20px}.fontHuge{font-size:35px}.fontxlHuge{font-size:70px}:host{display:block;height:100%}:host .card-selectable{display:flex;flex-direction:column;justify-content:space-between;padding:20px 30px 40px;border-radius:10px;background-color:#fff;box-shadow:0 0 15px #0000001a;height:100%;border:1px solid #fff}@media (max-width: 991.98px){:host .card-selectable{padding:20px 15px 40px}}:host .card-selectable.isSelected{border:1px solid #0098ff}:host .card-selectable:hover{transition:all .3s;box-shadow:0 10px 20px #0000001a,0 6px 6px #0000001a}:host .card-selectable .card-selectable-badge{position:absolute;top:0;transform:translateY(-50%);padding:3px 10px;border-radius:4px;background-color:#0098ff;color:#fff;font-size:14px;font-weight:500;text-align:center;right:45px}:host .card-selectable .card-selectable-header{margin-left:36px;color:#333;font-size:20px;font-weight:500;letter-spacing:0;line-height:22px}:host .card-selectable .card-selectable-header__separator{height:1px;width:100%;background-color:#f5f5f5;margin:24px 0}:host .card-selectable .card-selectable-main{margin-bottom:auto}:host .card-selectable .card-selectable-footer{margin-top:40px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.15", ngImport: i0, type: IkCardSelectableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ik-card-selectable',
                    templateUrl: './ik-card-selectable.component.html',
                    styleUrls: ['./ik-card-selectable.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { isSelected: [{
                type: Input
            }], badge: [{
                type: ViewChild,
                args: ['badge']
            }], header: [{
                type: ViewChild,
                args: ['header']
            }], main: [{
                type: ViewChild,
                args: ['main']
            }], footer: [{
                type: ViewChild,
                args: ['footer']
            }] } });

class IkCardSelectableModule {
}
IkCardSelectableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.15", ngImport: i0, type: IkCardSelectableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IkCardSelectableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.15", ngImport: i0, type: IkCardSelectableModule, declarations: [IkCardSelectableComponent], exports: [IkCardSelectableComponent] });
IkCardSelectableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.15", ngImport: i0, type: IkCardSelectableModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.15", ngImport: i0, type: IkCardSelectableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IkCardSelectableComponent],
                    imports: [],
                    exports: [IkCardSelectableComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { IkCardSelectableComponent, IkCardSelectableModule };
